import React, { useContext, useState } from 'react'
import GlobalContext from '../../../../contexts/globalContext';
import MentoriaAgendamientoCitas from '../mentoria-agendamiento-citas/mentoriaAgendamientoCitas';
import './mentoriaRuta.scss';

interface MentoriaRutaProps {
    results: any;
    agendamientoIcons: Array<string>;
    rutaPhotos: Array<string>;
}

const MentoriaRuta = ({ results, agendamientoIcons, rutaPhotos }: MentoriaRutaProps) => {
    const context = useContext(GlobalContext)
    const [currentReto, setCurrentReto] = useState(0);
    const [showAgendamiento, setShowAgendamiento] = useState(false);

    return (
        <>
            {showAgendamiento ? <MentoriaAgendamientoCitas icons={agendamientoIcons} showAgendamiento={setShowAgendamiento} />
                :
                <div className="mentoria-ruta">
                    <header className="mentoria-ruta__header">
                        <img
                            src={context.gigyaContext.gigyaAccount?.profile.photoURL || ""}
                            alt="Imagen de usuario"
                            className="mentoria-ruta__header__image"
                        />
                        <h2 className="mentoria-ruta__header__title">
                            {`${context.gigyaContext.gigyaAccount?.profile.firstName} ${context.gigyaContext.gigyaAccount?.profile.lastName}`}
                        </h2>
                        <section className="mentoria-ruta__header__info">
                            <h2 className="mentoria-ruta__header__info__number">
                                {results?.totalScore || 0}
                            </h2>
                            <div className="mentoria-ruta__header__info__description">
                                <h4 className="mentoria-ruta__header__info__description__title">
                                    Tu puntaje
                                </h4>
                                <p className="mentoria-ruta__header__info__description__subtitle">
                                    Puntaje máximo 100
                                </p>
                            </div>
                        </section>
                        <section className='mentoria-ruta__header__scores'>
                            {results?.score?.map((score, idx) => (
                                <div className="mentoria-ruta__header__scores__item">
                                    <div className="mentoria-ruta__header__scores__item__container">
                                        <h3 className="mentoria-ruta__header__scores__item__container__number" style={{ color: score.color || '#1AA8A2' }}>{score.value}</h3>
                                        <span className="mentoria-ruta__header__scores__item__container__text" style={{ color: score.color || '#1AA8A2' }}>Puntos</span>
                                        <p className="mentoria-ruta__header__scores__item__container__title">{score.name}</p>
                                    </div>
                                    {/* {(idx < 2) &&
                                <div className="mentoria-ruta__header__scores__item__divider"></div>
                            } */}
                                </div>
                            ))}
                        </section>
                    </header>
                    <main className="mentoria-ruta__main">
                        <section className="mentoria-ruta__main__proposito">
                            <img className="mentoria-ruta__main__proposito__image" src={rutaPhotos[0]} />
                            <div className="mentoria-ruta__main__proposito__info">
                                <h2 className="mentoria-ruta__main__proposito__info__title">Mi propósito</h2>
                                <p className="mentoria-ruta__main__proposito__info__text">Estas un paso más cerca de alcanzar tu propósito</p>
                                <p className="mentoria-ruta__main__proposito__info__text">Según el resultado de tu diagnóstico tienes unos puntos donde debes mejorar, para que trabajes en ellos te recomendamos este contenido que te explicarán algunas técnicas con las que puedes de aprender y acercarte a tu propósito</p>
                            </div>
                        </section>
                        <section className="mentoria-ruta__main__retos" style={{ backgroundColor: results.indicators[currentReto].backgroundColor || '#F6F8FF' }}>
                            <header className="mentoria-ruta__main__retos__nav">
                                {results.indicators.map((reto, idx) => (
                                    <button
                                        onClick={() => setCurrentReto(idx)}
                                        className="mentoria-ruta__main__retos__nav__item"
                                        style={{
                                            backgroundColor: currentReto >= idx ? (results.indicators[idx].color || '#B7BAD1') : '#EEEEEE',
                                            color: currentReto >= idx ? 'white' : '#A09F9F'
                                        }}
                                    >
                                        Reto {idx + 1}
                                    </button>
                                ))}
                            </header>
                            <div className="mentoria-ruta__main__retos__info">
                                <h2 className="mentoria-ruta__main__retos__info__title">{results.indicators[currentReto].name}</h2>
                                <p className="mentoria-ruta__main__retos__info__text">{results.indicators[currentReto].challengeDescription}</p>
                            </div>
                            <main
                                className="mentoria-ruta__main__retos__card"
                                style={{ backgroundColor: results.indicators[currentReto].backgroundColor || '#B7BAD1' }}
                            >
                                <img
                                    src={results.indicators[currentReto].urlImage}
                                    alt="Imagen reto"
                                    className="mentoria-ruta__main__retos__card__image"
                                />
                                <div className="mentoria-ruta__main__retos__card__description">
                                    <h3 className="mentoria-ruta__main__retos__card__description__title">{results.indicators[currentReto].title}</h3>
                                    <p className="mentoria-ruta__main__retos__card__description__text">{results.indicators[currentReto].challengeContent}</p>
                                    <a
                                        className="mentoria-ruta__main__retos__card__description__ver"
                                        href={results.indicators[currentReto].url}
                                        target="_blank"
                                        rel='noreferrer'
                                    >
                                        <p className="mentoria-ruta__main__retos__card__description__ver__text">Ver más</p>
                                        <div className="mentoria-ruta__main__retos__card__description__ver__icon">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" fill="currentColor" viewBox="0 0 16 16">
                                                <path fillRule="evenodd" d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5z" />
                                            </svg>
                                        </div>
                                    </a>
                                </div>
                                {/* <div className="mentoria-ruta__main__retos__card__done">
                                    <button
                                        className="mentoria-ruta__main__retos__card__done__button"
                                        onClick={() => { alert("Marcado como hecho!") }}
                                        style={{ backgroundColor: results.indicators[currentReto].color }}
                                        disabled
                                    >
                                        Ya lo hice
                                    </button>
                                </div> */}
                            </main>
                        </section>
                        {/* <section className="mentoria-ruta__main__mentor">
                            <div className="mentoria-ruta__main__mentor__info">
                                <h2 className="mentoria-ruta__main__mentor__info__title">¿Quieres programar una cita con un mentor?</h2>
                                <p className="mentoria-ruta__main__mentor__info__text">Programa tu cita y recibe un acompañamiento personalizado.</p>
                                <div
                                    className="mentoria-ruta__main__mentor__info__button"
                                    onClick={() => setShowAgendamiento(true)}
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="mentoria-ruta__main__mentor__info__button__icon" viewBox="0 0 16 16">
                                        <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z" />
                                    </svg>
                                    <p className="mentoria-ruta__main__mentor__info__button__text">AGENDA TU CITA</p>
                                </div>
                            </div>
                            <img
                                src={rutaPhotos[1]}
                                alt=""
                                className="mentoria-ruta__main__mentor__image"
                            />
                        </section> */}
                    </main>
                </div>
            }
        </>
    )
}

export default MentoriaRuta